// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/link-2.js';

import { paths } from '../generated/link-2';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('link-2', Original, paths);
